function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CartQuantity extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.minusButton = this.querySelector('.cart-quantity__minus');
    this.plusButton = this.querySelector('.cart-quantity__plus');
    this.input = this.querySelector('input');
    this.bindedHandleMinusButtonClick = this.handleMinusButtonClick.bind(this);
    this.bindedHandlePlusButtonClick = this.handlePlusButtonClick.bind(this);
    this.bindedHandleInputChange = debounce((event) => {this.handleInputChange(event);}, 300).bind(this)

    this.minusButton.addEventListener('click', this.bindedHandleMinusButtonClick);
    this.plusButton.addEventListener('click', this.bindedHandlePlusButtonClick);
    this.input.addEventListener('change', this.bindedHandleInputChange);
  }

  disconnectedCallback() {
    this.minusButton.removeEventListener('click', this.bindedHandleMinusButtonClick);
    this.plusButton.removeEventListener('click', this.bindedHandlePlusButtonClick);
    this.input.removeEventListener('change', this.bindedHandleInputChange);
  }
  
  handleMinusButtonClick(event) {
    event.preventDefault();

    this.changeQuantity(parseInt(this.input.value) - 1);
  }

  handlePlusButtonClick(event) {
    event.preventDefault();

    this.changeQuantity(parseInt(this.input.value) + 1);
  }

  handleInputChange(event) {
    event.preventDefault();

    this.changeQuantity(parseInt(this.input.value));
  }

  changeQuantity(quantity) {
    const body = JSON.stringify({
      line: this.dataset.index,
      quantity,
      sections: ['header', 'cart-drawer'],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json`}, ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          const errors = document.getElementById('cart-errors');
          errors.textContent = response.errors;
          return;
        }

        const newCart = new DOMParser().parseFromString(response.sections["cart-drawer"], "text/html");
        document.querySelector('.cart-drawer__container').innerHTML = newCart.querySelector('.cart-drawer__container').innerHTML;

        const newHeader = new DOMParser().parseFromString(response.sections["header"], "text/html");
        document.querySelectorAll('.header__cart-toggle').forEach(cartToggle => cartToggle.innerHTML = newHeader.querySelector('.header__cart-toggle').innerHTML);
      })
      .catch((error) => {
        const errors = document.getElementById('cart-errors');
        errors.textContent = 'Error occured while updating cart.';
      })
  }
}

customElements.define('cart-quantity', CartQuantity);

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.bindedHandleRemoveButtonClick = this.handleRemoveButtonClick.bind(this);

    this.addEventListener('click', this.bindedHandleRemoveButtonClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.bindedHandleRemoveButtonClick);
  }

  handleRemoveButtonClick(event) {
    event.preventDefault();

    const body = JSON.stringify({
      line: this.dataset.index,
      quantity: 0,
      sections: ['header', 'cart-drawer'],
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: `application/json`}, ...{ body } })
      .then((response) => {
        return response.json();
      })
      .then((response) => {
        if (response.errors) {
          const errors = document.getElementById('cart-errors');
          errors.textContent = response.errors;
          return;
        }

        const newCart = new DOMParser().parseFromString(response.sections["cart-drawer"], "text/html");
        document.querySelector('.cart-drawer__container').innerHTML = newCart.querySelector('.cart-drawer__container').innerHTML;

        const newHeader = new DOMParser().parseFromString(response.sections["header"], "text/html");
        document.querySelector('.header__cart').innerHTML = newHeader.querySelector('.header__cart').innerHTML;
      })
      .catch(() => {
        const errors = document.getElementById('cart-errors');
        errors.textContent = 'Error occured while updating cart.';
      })
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.cartButtons = document.querySelectorAll('.header__cart-toggle');
    this.handleOpenClick = this.handleOpenClick.bind(this);
    this.handleCloseClick = this.handleCloseClick.bind(this);

    this.dialog.addEventListener('click', this.handleCloseClick);
    this.cartButtons.forEach(ele => ele.addEventListener('click', this.handleOpenClick));
  }

  disconnectedCallback() {
    this.dialog.removeEventListener('click', this.handleCloseClick);
    this.cartButtons.forEach(ele => ele.removeEventListener('click', this.handleOpenClick));
  }

  handleOpenClick(event) {
    event.preventDefault();

    this.open();
  }

  handleCloseClick(event) {
    if (!event.target.closest('.cart-drawer__content') || event.target.closest('button[command="close"]')) {
      event.preventDefault();
      
      this.close();
    }
  }

  open() {
    this.dialog.showModal();
    setTimeout(() => this.dialog.classList.add('opening'));
  }

  close() {
    this.dialog.classList.remove('opening');

    this.dialog.addEventListener('transitionend', () => {
      this.dialog.close();
    }, {once: true})
  }
}

customElements.define('cart-drawer', CartDrawer);
